export default __webpack_public_path__ + "static/media/SemiPrivate2.8452abdb.jpeg";